const text = (value) => typeof value === "string" ? value.trim() : "";
const strings = (value) => Array.isArray(value) ? value.map(text).filter(Boolean) : [];
const unique = (values) => [...new Set(values)];

// Read only explicitly supplied catalogue fields. Retail and inventory fields
// never become product specifications, including on variant objects.
export function productPresentation(product = {}) {
  const variants = Array.isArray(product.variants) ? product.variants.filter((item) => item && typeof item === "object") : [];
  const primaryImages = strings(product.images);
  const suppliedLifestyle = strings(product.lifestyle_images);
  const images = unique([...primaryImages, ...suppliedLifestyle, ...strings(product.gallery), ...variants.flatMap((variant) => strings(variant.images))]);
  const lifestyle = suppliedLifestyle.length ? unique(suppliedLifestyle) : images.slice(1);
  const materials = unique([...strings(product.materials), text(product.material)].filter(Boolean));
  const variantText = variants.map((variant) => [
    text(variant.name),
    ...[["Finish", variant.finish], ["Colour", variant.color], ["Size", variant.size], ["SKU", variant.sku]]
      .filter(([, value]) => text(value)).map(([label, value]) => `${label}: ${text(value)}`),
  ].filter(Boolean).join(" · ")).filter(Boolean).join("\n");
  const attributes = [
    ["Materials", materials.join(", ")],
    ["Finish", text(product.finish)],
    ["Colour", text(product.color)],
    ["Dimensions", product.source_specs_verified === true ? "" : text(product.dimensions)],
    ["Weight", text(product.weight)],
    ["Care", text(product.care)],
    ["Variants", variantText],
  ].filter(([, value]) => value);
  const description = text(product.description);
  const shortDescription = text(product.short_description);
  const details = text(product.details);
  return {
    images, lifestyle, attributes, description, shortDescription, details,
    summary: shortDescription || description || details,
    alt: text(product.alt_text) || [text(product.name), text(product.sku)].filter(Boolean).join(" · "),
  };
}
